<template>
  <div class="users-list" v-loading="loading">
    <div style="display: flex; align-items: center; overflow: hidden">
      <el-input placeholder="Поиск (email, name, phone, company)..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search" @click="searchActive = search"></el-button>

      </el-input>
      <date-picker
        lang="ru"
        style="margin-left: 12px; margin-top: 8px"
        :editable="false"
        clearable
        ref="datePicker"
        placeholder="Фильтр по дате"
        v-model="datetimeRange"
        range
      ></date-picker>

      <i style="margin-left: 10px; font-size: 28px; margin-top: 8px; cursor: pointer" class="el-icon-refresh-right"
         @click="updateData"></i>
    </div>


    <div>
      <el-table
        :data="filteredList"
        style="width: 100%"
      >
        <el-table-column
          width="200"
          prop="email"
          label="Email"
        >
          <template slot-scope="scope">
            <router-link :to="`/dashboard/clients/${scope.row.uid}`">
              {{ scope.row.email }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          prop="name"
          label="Name"
        >
        </el-table-column>
        <el-table-column
          width="100"
          prop="phone"
          label="Phone"
        >
        </el-table-column>
        <el-table-column
          width="150"
          prop="company"
          label="Company"
        >
        </el-table-column>
        <el-table-column
          prop="start_date"
          label="Start date"
        >
          <template slot-scope="scope">
            <span>{{ dayjs(scope.row.start_date * 1000).format('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="170"
          prop="end_date"
          label="End date"
        >
          <template slot-scope="scope">
            <date-picker
              lang="ru"
              format="YYYY-MM-DD"
              style="width: 140px"
              ref="datePicker"
              @input="(e) => changeTime(e, scope.row.uid)"
              v-model="scope.row.end_date"
            ></date-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="companies"
          label="Созданых проектов"
        >
        </el-table-column>
        <el-table-column
          label="Приглашенный"
        >
          <template slot-scope="scope">
            <span class="is-invited">{{ scope.row.isInvited ? '+' : '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import AddProject from '@/views/Dashboard/Projects/components/AddProject';
import firebase from 'firebase';
import DatePicker from 'vue2-datepicker';
import dayjs from 'dayjs';
import _, {chunk} from 'lodash';
import {replaceUndefinedWithNull} from "../../../utils/numberUtils";

const isBetween = require('dayjs/plugin/isBetween');
dayjs.extend(isBetween);


const MAX_CONCURRENT_REQUESTS = 200; // Вы можете изменить это значение в зависимости от потребностей

async function fetchProjectUsers(chunks, projects_data = []) {
  let allUsers = [];
  for (let chunk of chunks) {
    const promises = chunk.map(project_id => {
      if (project_id.owner) {
        projects_data.push(project_id);
        return firebase.firestore()
          .collection('projects')
          .doc(project_id.id)
          .collection('users')
          .where('uid', '==', project_id.owner).get();
      }
      return Promise.resolve(null);
    });
    const users = await Promise.all(promises);
    allUsers = allUsers.concat(users.filter(u => u)); // Фильтруем, чтобы удалить возможные null-значения
  }
  return {all_users: allUsers, projects_data};
}


export default {
  name: 'List',
  components: {AddProject, DatePicker},
  data() {
    return {
      search: '',
      searchActive: '',
      busy: false,
      bottom: false,
      datetimeRange: [],
      loading: false,
      users: [],
      page: 0,
      allUsers: [],
      invites: [],
      rules: {
        'worker': 'Стандартный',
        'admin': 'Админ',
        'editor': 'Редактор',
      },
    };
  },

  mounted() {
    firebase.firestore().collection('superuser').where('user', '==', firebase.auth().currentUser.uid).get()
      .then(async (data) => {
        if (data.size) {
          this.fetchUsers();
        } else {
          this.$router.push('/');
        }
      });
  },
  methods: {
    async updateData() {
      this.loading = true;
      const db = firebase.firestore();
      const cacheDocRef = db.collection('cache').doc('cacheData');
      const usersSubcollectionRef = cacheDocRef.collection('users');

      const result = [];
      let users_result = [];
      const projects_data = [];
      const usersStats = []
      firebase.firestore().collection('userStat').get().then(async (data) => {
        data.forEach((sub) => {
          const data = sub.data();
          usersStats.push({
            ...data
          });
        });

        firebase.firestore().collection('projects').get().then(async (data) => {
          data.forEach((sub) => {
            const data = sub.data();
            result.push({
              id: sub.id,
              owner: data.owner,
              start_date: data.start_date,
              phone: data.phone,
              end_date: new Date(data.end_date * 1000),
            });
          });
        }).finally(async () => {

          const chunks = [];
          for (let i = 0; i < result.length; i += MAX_CONCURRENT_REQUESTS) {
            chunks.push(result.slice(i, i + MAX_CONCURRENT_REQUESTS));
          }


          fetchProjectUsers(chunks, projects_data).then(async ({all_users, projects_data}) => {
            all_users.forEach((users, key) => {
              users.forEach((data) => {
                const user = data.data();
                const isset_user = users_result.findIndex((u) => user.uid === u.uid);
                if (isset_user !== -1) {
                  users_result[isset_user].start_date = projects_data[key].start_date;
                  users_result[isset_user].end_date = projects_data[key].end_date;
                  users_result[isset_user].companies += 1;
                  if (user.isInvited) {
                    users_result[isset_user].isInvited = true;
                  }
                } else {
                  users_result.push({
                    ...data.data(),
                    start_date: projects_data[key].start_date,
                    end_date: projects_data[key].end_date,
                    companies: 1,
                  });
                }
              });
            });

            users_result = users_result.map((user) => {
              const u = usersStats.find((us) => {
                return (us.email || '').toLowerCase() === (user.email || '').toLowerCase()
              })

              if (u) {
                user.start_date = u.createDate
              }

              if (user.start_date === null) user.start_date = 0

              return user
            })


            usersStats.forEach((u) => {
              const userIndex = users_result.findIndex((res) => res.uid === u.uid)
              if (userIndex === -1) {
                users_result.push({
                  companies: u.own_projects,
                  company: u.company,
                  email: u.email,
                  end_date: new Date(u.end_date ? u.end_date * 1000 : dayjs(u.createDate * 1000).add(1, 'months').format()),
                  isInvited: null,
                  name: u.name,
                  phone: u.phone,
                  position: null,
                  role: null,
                  start_date: u.createDate,
                  uid: u.uid
                })
              } else {
                if (!users_result[userIndex].end_date) {
                  users_result[userIndex].end_date = new Date(u.end_date ? u.end_date * 1000 : dayjs(u.createDate * 1000).add(1, 'months').format())
                }
              }
            })

            await cacheDocRef.delete();

            // Записываем финальные данные в cacheCollection с использованием batch
            const batch = db.batch();
            users_result.forEach(user => {
              const docRef = usersSubcollectionRef.doc(user.uid); // создаем новый документ для каждого пользователя
              batch.set(docRef, {...replaceUndefinedWithNull(JSON.parse(JSON.stringify(user)))});
            });
            await batch.commit(); // выполнить batch операцию

            await this.fetchUsers()
            this.loading = false
          });
        });
      });
    },
    async changeTime(input, uid) {
      const projects = await firebase.firestore()
        .collection('projects')
        .where(`owner`, '==', uid)
        .get();

      const batch = firebase.firestore().batch();
      projects.forEach(doc => {
        batch.update(doc.ref, {
          ...doc.data(),
          end_date: dayjs(input).utc().unix(),
        });
      });

      await batch.commit();


      const userStats = await firebase.firestore()
        .collection('userStat')
        .where(`uid`, '==', uid)
        .get();

      const batchUser = firebase.firestore().batch();
      userStats.forEach(doc => {
        batchUser.update(doc.ref, {
          ...doc.data(),
          end_date: dayjs(input).utc().unix(),
        });
      });
      const db = firebase.firestore();


      const cacheDocRef = db.collection('cache').doc('cacheData');
      const usersSubcollectionRef = cacheDocRef.collection('users');

      await batchUser.commit();

      await usersSubcollectionRef.doc(uid).update({
        end_date: dayjs(input).utc().unix() * 1000,
      })
      this.loading = false;
    },
    dayjs,
    async fetchUsers() {
      this.loading = true
      const db = firebase.firestore();
      const cacheDocRef = db.collection('cache').doc('cacheData');
      const usersSubcollectionRef = cacheDocRef.collection('users');
      const snapshot = await usersSubcollectionRef.get();

      let users_result = snapshot.docs.map(doc => {
        const data = doc.data()
        return {
          id: doc.id,
          ...data,
        }
      });
      const users = _.orderBy(users_result, 'start_date', ['desc']);
      this.allUsers = users.map((user) => ({
        ...user,
        end_date: user.end_date ? new Date(user.end_date) : null
      }))

      this.page = 0
      this.loading = false
    },
  },
  computed: {
    filteredList() {
      if (this.datetimeRange.length && this.datetimeRange[0] && this.datetimeRange[1]) {
        return [...this.allUsers.filter(item => dayjs(item.start_date * 1000).isBetween(this.datetimeRange[0], this.datetimeRange[1], null, '[]'))];
      }

      if (this.searchActive && this.searchActive.length) {
        return [
          ...this.allUsers.filter(item =>
            (
              String(item.email).includes(this.searchActive) ||
              String(item.phone).includes(this.searchActive) ||
              String(item.company).includes(this.searchActive) ||
              String(item.name).includes(this.searchActive))
          )
        ];
      }

      return chunk(this.allUsers, 100)[0]
    },
  },
};
</script>

<style scoped lang="scss">
.users-list {
  max-width: 1400px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.input-search {
  margin-top: 12px;
}

.name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  small {
    font-size: 12px;
    font-weight: bold;
  }
}

.users-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .users-li, > > > .users-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 64px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 0 12px;


    &.active {
      background: rgba(54, 118, 203, 0.26) !important;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.add-user {
  margin-top: 22px;
  text-decoration: none;
  color: #3676CB;

  &:hover {
    color: #222;
  }
}

.controls {
  margin-top: 30px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
}

.users-invites {
  margin-top: 20px;

  .name, .email {
    opacity: 0.5;
  }
}

.users-controls {
  display: flex;
  justify-content: flex-end;

  i {
    margin-left: 16px;
  }
}

.is-invited {
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Admin/Clients/List.vue